export default __webpack_public_path__ + "static/media/checkedNew-white.df6949c7.svg";